import {
  IconWarning20,
  Tab,
  TabBar,
} from '@lightspeed/unified-components-helios-theme/react'
import { useT } from '@transifex/react'
import React from 'react'
import { LineItemTab } from '../../../../../types/lineItemTabs'
import { Tooltip } from '../../../shared/Tooltip'
import { LineItemTabsProps, useLineItemTabsModel } from './useLineItemTabsModel'

export const LineItemTabs = (props: LineItemTabsProps) => {
  const t = useT()
  const model = useLineItemTabsModel(props)

  return (
    <div className="vd-mb3">
      {model.shouldShowTabs && (
        <TabBar
          value={model.currentTab}
          onChange={model.onTabChange}
          size="large"
        >
          <Tab
            value={LineItemTab.DETAIL}
            customDataAttributes={{
              container: {
                'data-track': 'details',
                'data-testid': 'tab-button-detail',
              },
            }}
          >
            {t('Details', { _context: 'Line item tabs' })}
          </Tab>

          <Tooltip
            disabled={!model.params[LineItemTab.FULFILMENT].disabled}
            placement="bottom"
            controlSlot={
              <Tab
                disabled={model.params[LineItemTab.FULFILMENT].disabled}
                value={LineItemTab.FULFILMENT}
                customClasses={{
                  container: model.params[LineItemTab.FULFILMENT].disabled
                    ? 'hover:text-neutral-inert-default hover:border-b-neutral-default'
                    : '',
                }}
                customDataAttributes={{
                  container: {
                    'data-track': 'fulfillment',
                    'data-testid': 'tab-button-fulfilment',
                  },
                }}
                prefixSlot={
                  model.params[LineItemTab.FULFILMENT].hasWarning && (
                    <span
                      data-testid="line-item-icon-error"
                      className="text-no-default"
                    >
                      <IconWarning20 />
                    </span>
                  )
                }
              >
                {t('Fulfillment', { _context: 'Line item tabs' })}
              </Tab>
            }
          >
            {t('Fulfillment method can’t be added for returns.', {
              _context: 'Fulfillment tab disabled tooltip message',
            })}
          </Tooltip>
        </TabBar>
      )}
    </div>
  )
}
